import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { ScrollTop } from '@/components/element/ScrollTop';
import { TaskSummary } from '@/components/features/tasks/invoice/TaskSummary';
import { TaskProgress } from '@/components/features/tasks/invoice/TaskProgress';
import { TaskFiles } from '@/components/features/tasks/invoice/TaskFiles';
import { Comments } from '@/components/features/tasks/invoice/Comments';
import { ToDoList } from '@/components/features/tasks/invoice/ToDoList';
import { Activities } from '@/components/features/tasks/invoice/Activities';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { ProjectInfo } from '@/components/features/tasks/invoice/ProjectInfo';
import { GenerateAfterCompletedAlert } from '@/components/features/tasks/invoice/GenerateAfterCompletedAlert';

export const BackofficeInvoiceTask = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  const { _w_ } = useCurrentWorkspace();
  useEffect(() => setTitle('請求タスク詳細'), []);
  useEffect(
    () => setBreadcrumbs([{ label: `請求タスク一覧`, path: `/w/${_w_!.identifier}/backoffice/invoice_tasks` }]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <div className="row mb-4">
          <GenerateAfterCompletedAlert />

          <div className="col-12 col-lg-7">
            <ToDoList />

            <TaskFiles />

            <Comments />
          </div>

          <div className="col-12 col-lg-5">
            <TaskSummary />

            <TaskProgress />

            <ProjectInfo />

            <Activities />
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
